<app-navbar></app-navbar>

<app-notifications></app-notifications>

<main class="flex-grow">
  <router-outlet></router-outlet>
</main>

<!-- <app-footer></app-footer> -->